import { render, staticRenderFns } from "./suratjalankoli.vue?vue&type=template&id=6476b486"
import script from "./suratjalankoli.vue?vue&type=script&lang=js"
export * from "./suratjalankoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports